/** Adopted from https://stackoverflow.com/a/901144/2723138
 *
 * Get Parameters value by name
 * Example usage: var foo = getParameterByName('from_date');
 *
 * @author Matt Haynes <matthew.haynes@joipolloi.com>
 * @package The University of Sheffield - Performance Venues
 */

const getParameterByName = (name, url) => {
    let paramUrl = url;
    let paramName = name;
    if (!paramUrl) paramUrl = window.location.href;
    paramName = paramName.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${paramName}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(paramUrl);
    if (!results) return null;
    if (!results[2]) return '';

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export default getParameterByName;
